import * as React from "react"
import {
  CreateButton,
  DatagridConfigurable,
  DateField,
  List,
  SearchInput,
  TopToolbar,
  TextField,
  EmailField,
  useListContext,
  useRecordContext,
  BulkDeleteButton,
  DeleteWithConfirmButton
} from "react-admin"
import { useMediaQuery, Button, Box, Typography } from "@mui/material"
import ContentFilter from '@mui/icons-material/FilterList';
import ContactFilterForm from "./ContactFilterForm"

const ContactFilterButton = () => {
  const { showFilter } = useListContext()
  return (
    <Button
      size="small"
      color="primary"
      onClick={() => showFilter("main")}
      startIcon={<ContentFilter />}
      sx={{
        height: '27.5px', // 調整按鈕高度
        padding: '4px 5px', // 調整內邊距
        fontSize: '13px', // 調整字型大小，這樣可以與 CreateButton 大小對齊
      }}
    >
      篩選
    </Button>
  )
}

const mobileFilters = [
  <SearchInput source="q" alwaysOn />
]

const ContactListActions = () => (
  <Box width="100%">
    <TopToolbar>
      <ContactFilterButton />
      <CreateButton />
    </TopToolbar>
    <ContactFilterForm />
  </Box>
)

const ContactBulkActionButtons = () => (
  <>
    <BulkDeleteButton 
      confirmTitle="確認刪除"
      confirmContent="您確定要刪除這些聯絡表單嗎？"
      mutationMode="optimistic"
    />
  </>
);

const ContactTitle = () => {
  return <span>{'聯絡表單'}</span>;
};

const ContactList = () => {
  const isXsmall = useMediaQuery(theme => theme.breakpoints.down("sm"))
  const isSmall = useMediaQuery(theme => theme.breakpoints.down("md"))

  const TruncatedTextField = ({ source, maxLength = 30 }) => {
    const record = useRecordContext();
    const text = record?.[source] || '';
    const truncatedText = text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;

    return (
      <Typography variant="body2" title={text}>
        {truncatedText}
      </Typography>
    );
  };

  return (
    <List
      title={<ContactTitle/>}
      filters={isSmall ? mobileFilters : undefined}
      sort={{ field: "createdAt", order: "DESC" }}
      perPage={25}
      actions={<ContactListActions />}
    >
      {isXsmall ? (
        <div></div>
      ) : (
        <DatagridConfigurable
          rowClick="edit"
          bulkActionButtons={<ContactBulkActionButtons />}
          sx={{
            "& .column-groups": {
              md: { display: "none" },
              lg: { display: "table-cell" }
            }
          }}
          omit={["id"]}
        >
          <TextField
            source="id"
            label="ID"
          />
          <TextField
            source="statusName"
            label="處理狀況"
            sortBy="status"
          />
          <TextField
            source="requestTypeName"
            label="需求類型"
            sortBy="requestType"
          />
          <TextField
            source="name"
            label="客戶名稱"
          />
          <EmailField
            source="email"
            label="Email"
          />
          <TextField
            source="phone"
            label="聯絡電話"
          />
          <TruncatedTextField 
            source="message" 
            maxLength={15} 
            label="詳細內容"
          />
          <TruncatedTextField 
            source="response" 
            maxLength={15} 
            label="紀錄備註"
          />
          <DateField 
            source="createdAt" 
            label="建立日期"  
            showTime
          />
          <DateField 
            source="resolvedAt" 
            label="完成日期"  
            showTime
          />
          <DeleteWithConfirmButton
            confirmTitle="確認刪除"
            confirmContent="您確定要刪除此聯絡表單嗎？"
          />
        </DatagridConfigurable>
      )}
    </List>
  )
}

export default ContactList